import styled from 'styled-components'

import { red, white, black } from '../../styles/colors'
import { minmedia, maxmedia } from '../../styles/media-queries'

export const Container = styled.div`
  background-image: ${props => (props.background ? `url('../../assets/${props.background}')` : red)};
  position: relative;
  padding: 2rem 1.5rem;

  ${minmedia.medium`
    padding: 2rem;
  `}
  ${minmedia.xmlarge`
    padding: 3rem;
  `}
`

export const Background = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  z-index: -1;
`

export const Title = styled.h4`
  color: ${white};
  font-size: 18px;
  width: 100%;
  text-shadow: 1px 1px 5px ${black};
  margin: 0;

  ${maxmedia.medium`
    font-weight: 300;
  `}
  ${minmedia.medium`
    font-size: 20px;
    margin-bottom: 1rem;
  `}
  ${minmedia.xxlarge`
    font-size: 32px;
    margin-bottom: 1.5rem;
  `}
`

export const Description = styled.p`
  color: ${white};
  font-size: 18px;
  width: 100%;
  text-shadow: 1px 1px 5px ${black};
  margin: 0;

  ${maxmedia.medium`
    display: none;
  `}
  ${minmedia.xxlarge`
    font-size: 20px;
  `}
`



// WEBPACK FOOTER //
// ./src/components/ProductIntro/styles.js